export const capitalizeFirstLetter = (stringToCapitalize?: string): string | undefined => {
    return stringToCapitalize
        ? stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1)
        : undefined;
};

export const truncateString = (str: string, num: number) => {
    if (str.length > num) {
        return str.slice(0, num) + '...';
    }

    return str;
};

/**
 * Lowercases, strips diacritics (č→c, š→s, đ→d, …) and trims — the JS twin of the
 * backend TextNormalizer, so client-side search matches accent-insensitively.
 */
export const normalizeText = (value?: string | null): string =>
    (value ?? '')
        .toLowerCase()
        .replace(/đ/g, 'd')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

/**
 * Accent-insensitive filterOption for antd <Select showSearch> — matches against
 * the option label (options prop) or children (Select.Option text).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const filterOptionNormalized = (input: string, option: any): boolean => {
    const text = option?.label ?? option?.children ?? '';

    return normalizeText(String(text)).includes(normalizeText(input));
};
